// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[3].use[1]!../../../node_modules/normalize.css/normalize.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[3].use[1]!../../../node_modules/@blueprintjs/icons/lib/css/blueprint-icons.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[3].use[1]!../../../node_modules/@blueprintjs/core/lib/css/blueprint.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[3].use[1]!../../../node_modules/@blueprintjs/datetime/lib/css/blueprint-datetime.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.k-form-field {
  padding: 0 15px;
  float: left;
  width: 50%;
}
.k-form-field label {
  text-align: left;
}
.k-form-field .label {
  align-self: center;
  flex-shrink: 0;
  margin: 7px 0 4px 0;
  font-size: 14px;
}
.k-form-field .label.k-checkbox-label {
  font-size: 15px;
  line-height: 20px;
}
.k-form-field .k-checkbox-label::after,
.k-form-field .k-checkbox-label::before {
  width: 20px;
  height: 20px;
  font-size: 20px;
}
.k-form-field.wrap {
  flex-wrap: wrap;
}
.k-form-field .k-dropdown,
.k-form-field .k-timepicker,
.k-form-field .k-datepicker,
.k-form-field > .k-textbox {
  width: 288px;
  max-width: 100%;
}
.k-form-field .emailTemplate.k-textbox {
  width: 248px;
}
.k-form-field textarea.k-textbox {
  resize: vertical;
}
.k-form-field .k-timepicker .k-input {
  margin: 3px 0;
  height: 5.42px;
}
.k-form-field .k-datepicker .k-picker-wrap .k-input {
  font-size: 13px;
  margin: 4px 0;
  height: 22px;
  box-shadow: none;
}
.k-form-field .k-combobox {
  width: auto;
}
.k-form-field .k-textbox[type='range'] {
  -webkit-appearance: slider-horizontal;
  -moz-appearance: initial;
}
.k-form-field .k-textbox[type='range']:focus {
  box-shadow: none;
}
.k-form-field.range .min {
  float: left;
  font-size: 12px;
}
.k-form-field.range .max {
  float: right;
  font-size: 12px;
}
.k-form-field input[type='date'] {
  -webkit-min-logical-width: calc(100% - 16px);
  border-width: 1px;
  border-radius: 2px;
  border-style: solid;
  font-family: 'sofia-pro', sans-serif;
  line-height: 100%;
  padding: 4px 8px;
  display: inline-flex;
}
.k-form-field .optional {
  font-style: italic;
}
.k-form .k-form-field > span:not(.k-widget) {
  padding: 0;
}
.fileUploadField .loadingPanel {
  position: absolute;
  top: 0;
}
@media (max-width: 599px) {
  .k-form-field .label.k-checkbox-label {
    font-size: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/commonComponents/fields/fieldStyles.less"],"names":[],"mappings":"AAOA;EACC,eAAA;EACA,WAAA;EACA,UAAA;AAFD;AADA;EAME,gBAAA;AAFF;AAJA;EAUE,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;AAHF;AAVA;EAiBE,eAAA;EACA,iBAAA;AAJF;AAdA;;EAuBE,WAAA;EACA,YAAA;EACA,eAAA;AALF;AAQC;EACC,eAAA;AANF;AAvBA;;;;EAoCE,YAAA;EACA,eAAA;AAPF;AA9BA;EAyCE,YAAA;AARF;AAjCA;EA6CE,gBAAA;AATF;AApCA;EAiDE,aAAA;EACA,cAAA;AAVF;AAxCA;EAwDI,eAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;AAbJ;AA9CA;EAiEE,WAAA;AAhBF;AAjDA;EAqEE,qCAAA;EACA,wBAAA;AAjBF;AAkBE;EACC,gBAAA;AAhBH;AAoBC;EAEE,WAAA;EACA,eAAA;AAnBH;AAgBC;EAME,YAAA;EACA,eAAA;AAnBH;AAhEA;EAwFE,4CAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oCAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;AArBF;AA1EA;EAmGE,kBAAA;AAtBF;AA0BA;EACC,UAAA;AAxBD;AA2BA;EACC,kBAAA;EACA,MAAA;AAzBD;AA4BA;EACC;IAEE,eAAA;EA3BD;AACF","sourcesContent":["@import (reference) '../constants.less';\n@import (reference) '../../appComponents/constants.less';\n@import '~normalize.css/normalize.css';\n@import '~@blueprintjs/icons/lib/css/blueprint-icons.css';\n@import '~@blueprintjs/core/lib/css/blueprint.css';\n@import '~@blueprintjs/datetime/lib/css/blueprint-datetime.css';\n\n.k-form-field {\n\tpadding: 0 15px;\n\tfloat: left;\n\twidth: 50%;\n\n\tlabel {\n\t\ttext-align: left;\n\t}\n\n\t.label {\n\t\talign-self: center;\n\t\tflex-shrink: 0;\n\t\tmargin: 7px 0 4px 0;\n\t\tfont-size: 14px;\n\t}\n\n\t.label.k-checkbox-label {\n\t\tfont-size: 15px;\n\t\tline-height: 20px;\n\t}\n\n\t.k-checkbox-label::after,\n\t.k-checkbox-label::before {\n\t\twidth: 20px;\n\t\theight: 20px;\n\t\tfont-size: 20px;\n\t}\n\n\t&.wrap {\n\t\tflex-wrap: wrap;\n\t}\n\n\t.k-dropdown,\n\t.k-timepicker,\n\t.k-datepicker,\n\t& > .k-textbox {\n\t\twidth: @inputWidth;\n\t\tmax-width: 100%;\n\t}\n\n\t.emailTemplate.k-textbox {\n\t\twidth: (@inputWidth - 40px);\n\t}\n\n\ttextarea.k-textbox {\n\t\tresize: vertical;\n\t}\n\n\t.k-timepicker .k-input {\n\t\tmargin: 3px 0;\n\t\theight: (4px + 1.42em);\n\t}\n\n\t.k-datepicker {\n\t\t.k-picker-wrap {\n\t\t\t.k-input {\n\t\t\t\tfont-size: 13px;\n\t\t\t\tmargin: 4px 0;\n\t\t\t\theight: 22px;\n\t\t\t\tbox-shadow: none;\n\t\t\t}\n\t\t}\n\t}\n\n\t.k-combobox {\n\t\twidth: auto;\n\t}\n\n\t.k-textbox[type='range'] {\n\t\t-webkit-appearance: slider-horizontal;\n\t\t-moz-appearance: initial;\n\t\t&:focus {\n\t\t\tbox-shadow: none;\n\t\t}\n\t}\n\n\t&.range {\n\t\t.min {\n\t\t\tfloat: left;\n\t\t\tfont-size: 12px;\n\t\t}\n\t\t.max {\n\t\t\tfloat: right;\n\t\t\tfont-size: 12px;\n\t\t}\n\t}\n\n\tinput[type='date'] {\n\t\t-webkit-min-logical-width: calc(100% - 16px);\n\t\tborder-width: 1px;\n\t\tborder-radius: 2px;\n\t\tborder-style: solid;\n\t\tfont-family: @sofiaFont;\n\t\tline-height: 100%;\n\t\tpadding: 4px 8px;\n\t\tdisplay: inline-flex;\n\t}\n\n\t.optional {\n\t\tfont-style: italic;\n\t}\n}\n\n.k-form .k-form-field > span:not(.k-widget) {\n\tpadding: 0;\n}\n\n.fileUploadField .loadingPanel {\n\tposition: absolute;\n\ttop: 0;\n}\n\n@media (max-width: @phoneOnlyMaxWidth) {\n\t.k-form-field {\n\t\t.label.k-checkbox-label {\n\t\t\tfont-size: 14px;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
